const clickOutside = {
    beforeMount: (el, binding) => {
        el.clickOutsideEvent = event => {
            if (!(el == event.target || el.contains(event.target))) {
                binding.value();
            }
        };
        document.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted: el => {
        document.removeEventListener("click", el.clickOutsideEvent);
    },
};
const ReadMoreComponent = {
    props: {
        moreStr: {
            type: String,
            default: "Read More"
        },
        lessStr: {
            type: String,
            default: "Close"
        },
        shortDescription: {
            type: String,
            required: true
        },
        benefits: {
            type: String,
            required: true
        },
        link: {
            type: String,
            default: "#"
        }
    },
    data() {
        return {
            isReadMore: false
        };
    },
    methods: {
        toggleReadMore(e) {
            e.preventDefault();
            this.isReadMore = !this.isReadMore;
        }
    },
    template: `
        <div class="product__description rte">
            <div v-html="shortDescription"></div>
            <div v-if="isReadMore" v-html="benefits"></div>
            <span class="readmore-toggle">
                <a :href="link" v-show="!isReadMore" @click="toggleReadMore">{{ moreStr }}</a>
                <a :href="link" v-show="isReadMore" @click="toggleReadMore">{{ lessStr }}</a>
            </span>
        </div>
    `
};

const ProductQuickView = {
    props: {
        item: Object,
        i18n: Object
    },
    emits: ['openQuickView'],
    computed: {

    },
    methods: {
        openQuickView() {
            this.$emit('openQuickView',this.item);
        },
        closeQuickView() {
            console.log('closeQuickView')
        },
    },
    template: `<div class="quick-view-btn" @click.stop="openQuickView"><span>Quick View</span></div>`
}
const ProductSticker = {
    props: {
        item: Object,
        i18n: Object
    },
    computed: {

    },
    template: `
    <div v-for="tag in item.tags">
        <div v-if="tag.indexOf('sticker:') !== -1" class="thumbnail-sticker" :class="tag.replace('sticker:', '').replace(' ', '-').concat('-sticker')">
            <strong class="sticker-text">{{tag.replace('sticker:', '')}}</strong>
        </div>
    </div>
    `
}
const ProductGridPrice = {
    props: {
        item: Object
    },
    computed: {
        priceMinMax() {
            if (this.item.price_varies === 'true' && this.item.price_min > 0) {
                let price_min_max = this.item.price_max
                this.item.variants.forEach((variant) => {
                    const variant_price = variant.price
                    const variant_name = variant.title.toLowerCase()
                    if(variant_name.indexOf('sample') === -1) {
                        if (variant_price <= price_min_max) {
                            price_min_max = variant_price
                        }
                    }
                })
                return price_min_max
            }
        },
        getPrices() {
            let compareAtPrice = this.item.compare_at_price_max;
            let compareAtPriceMin = this.item.compare_at_price_min;
            let price = this.item.price;
            let discountValue = price;
            let saleCollection = (this.item && this.item.collections) ? this.item.collections.filter((collection) => collection.metafields.discount_value && collection.metafields.discount_type)[0] : null;
            if (this.item.type == 'Gift Cards') saleCollection = null;
            if (saleCollection) {
                if(saleCollection.metafields.discount_type == 'percent') {
                  let percentOff = (100 - parseFloat(saleCollection.metafields.discount_value)) * 0.01;
                  discountValue = discountValue * percentOff;
                } else{
                  let discount = parseFloat(saleCollection.metafields.discount_value) * 100;
                  discountValue = Math.max(discountValue - discount, 0);
                }
                compareAtPrice = Math.max(price, compareAtPrice);
            }
            return {
                price: price,
                discountValue: discountValue,
                compareAtPrice: compareAtPrice,
                compareAtPriceMin: compareAtPriceMin
            }
        }
    },
    methods: {
        print(amount) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount/100);
        },
    },
    template: `
    <div class="price" :class="{'sold-out': !item.available}">
      <div class="price__container" :class="priceMinMax">
        <template v-if="item.available">
          <template v-if="item.price_varies === 'true' && item.price_min > 0">
            <template v-if="priceMinMax > 0 && priceMinMax < item.price_max">
              <div class="price__range--compare money-red" v-if="getPrices['compareAtPriceMin'] > 0">
                <span class="money">{{print(getPrices['compareAtPriceMin'])}} - </span><span class="money" v-if="getPrices['compareAtPrice'] > 0">{{print(getPrices['compareAtPrice'])}}</span>
              </div>
              <div class="price__range--original" :class="{'money-compare': getPrices['compareAtPriceMin'] > 0}">
              <span class="money">{{print(priceMinMax)}}</span> - <span class="money">{{print(item.price_max)}}</span>
              </div>
            </template>
            <template v-else>
              <span class="money">{{print(item.price_max)}}</span>
            </template>
          </template>
          <template v-else-if="item.price_min > 0">
              <span class="money" :class="{'money-red': getPrices['compareAtPrice'] > getPrices['price'] || getPrices['compareAtPrice'] > getPrices['discountValue']}">{{print(getPrices['discountValue'])}}</span>
              <span v-if="getPrices['compareAtPrice'] > getPrices['price'] || getPrices['compareAtPrice'] > getPrices['discountValue']">&nbsp;&nbsp;<s class="money-compare">{{print(getPrices['compareAtPrice'])}}</s></span>
          </template>
          <template v-else>FREE</template>
        </template>
        <template v-else>
          <span class="product-thumbnail__sold-out sold-out">Out of stock</span>
        </template>
      </div>
    </div>
    `
}
const QuickViewCarousel = {
    data() {
        return {

        }
    },
    computed: {
        currentImage() {
            if(this.startingImage !== null
                && this.startingImage >= 0
                && this.startingImage < this.images.length) {
                return this.images[this.startingImage];
            }
        }
    },
    methods: {
        nextImage() {
            var active = this.startingImage + 1;
            if(active >= this.images.length) {
                active = 0;
            }
            this.activateImage(active);
        },
        prevImage() {
            var active = this.startingImage - 1;
            if(active < 0) {
                active = this.images.length - 1;
            }
            this.activateImage(active);
        },
        activateImage(imageIndex) {
            this.$emit('changeImage', imageIndex);
        }
    },
    emits: ['changeImage'],
    props: ['startingImage', 'images'],
    template: `<div class="card-carousel">
        <div class="card-img">
            <img :src="currentImage.src" alt="" v-if="currentImage.media_type === 'image'">
            <div class="embed-container" v-else>
                <iframe frameborder="0" allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" :src="'https://www.youtube.com/embed/'+currentImage.external_id"></iframe>
            </div>
        </div>
        <div class="thumbnails light--scrollbar">
            <div 
                v-for="(image, index) in  images"
                :key="image.id"
                :class="['thumbnail-image', (startingImage == index) ? 'active' : '', (image.media_type !== 'image') ? 'thumbnail-video':'']"
                @click="activateImage(index)"
            >
                <img :src="(image.media_type === 'image') ? image.src : image.preview_image.src ">
            </div>
        </div>
    </div>`
}
const QuickViewModal = {
    components: {
        'carousel': QuickViewCarousel,
        'currency': ProductGridPrice,
        'readmore': ReadMoreComponent
    },
    data() {
        return {
            quantity: 1,
            selectedVariant: null,
            selectedVariantId: this.item.selected_or_first_available_variant,
            selectedVariantImage: 0
        }
    },
    props: {
        show: Boolean,
        loading: Boolean,
        item: Object
    },
    computed: {
        images() {
            let images = false
            this.selectedVariantImage = 0;
            if(this.item.hasOwnProperty('media') && this.item.media.length > 0) {
                images = []
                this.item.media.forEach((mediaObject, index) => {
                    images.push(mediaObject);
                    if(this.selectedVariant &&
                        this.selectedVariant.hasOwnProperty('featured_media') &&
                        this.selectedVariant.featured_media &&
                        this.selectedVariant['featured_media'].hasOwnProperty('id') &&
                        this.selectedVariant['featured_media'].id === mediaObject.id) {
                        this.selectedVariantImage = index;
                    }
                })
            }
            return images
        },
        qtyId() {
            return 'qty-'+this.item.id;
        },
        qtyName() {
            return 'qty['+this.item.id + ']';
        },
        sortedVariants() {
            if (!this.item || !this.item.variants) return [];

            return this.item.variants.slice().sort((a, b) => {
                const getPriority = (variant) => {
                    const size = variant.product_size ? variant.product_size.toLowerCase() : '';
                    if (size.includes("full size")) return 1;
                    if (size.includes("travel")) return 2;
                    if (size.includes("refill")) return 3;
                    return 4;
                };
                return getPriority(a) - getPriority(b);
            });
        }
    },
    emits: ['addToCart'],
    methods: {
        changeImage(index) {
            this.selectedVariantImage = index;
        },
        onEnter(el) {
            this.selectedVariantId = this.item.selected_or_first_available_variant;
            this.item.variants.forEach((variant) => {
                if(variant.id === this.selectedVariantId) {
                    this.selectedVariant = variant;
                }
            })
        },
        onAfterLeave(el) {
            document.body.classList.remove('overflow-hidden');
        },
        onQtyButtonClick() {
            let qty = this.quantity;
            event.target.name === 'plus' || event.target.parentNode.name === 'plus' ? qty++ : qty--;
            if(qty < 1) {
                qty = 1;
            }
            if(qty !== this.quantity) {
                this.quantity = qty;
            }
        },
        updateProductQty() {
            let qty = parseInt(event.target.value);
            if(qty < 1) {
                qty = 1;
            }
            if(qty !== this.quantity) {
                this.quantity = qty;
            }
        },
        selectVariant(event) {
            if (event.target.closest('.variant-selects')) {
              const selects = event.target.closest('.variant-selects').querySelectorAll('.select__select');
              let optionTitle = [];
              selects.forEach((select) => {
                optionTitle.push(select.value)
              });
              optionTitle = optionTitle.join(' / ');
              const variantSelector = event.target.closest('.variant-selects').querySelector(`[data-variant-selector]`);
              variantSelector.querySelectorAll('option').forEach((option) => {
                if (option.dataset.title == optionTitle) this.selectedVariantId = parseInt(option.value);
              });
            } else {
            this.selectedVariantId = parseInt(event.target.value);
            }
            this.item.variants.forEach((variant) => {
                if(variant.id === this.selectedVariantId) {
                    this.selectedVariant = variant;
                }
            });
            if (event.target.closest('.variant-selects')) {
              this.updateVariantSelects(event.target.closest('.variant-selects'));
            }
        },
        updateVariantSelects(element) {
          const selects = element.querySelectorAll('.select__select');
          let optionsList = [];
          selects.forEach((select) => {
            optionsList.push(select.value)
          });
          
          selects.forEach((select, index) => {
            const options = select.querySelectorAll('option');
            const variantIndex = `option${index+1}`;

            options.forEach((option) => {
              let dumpList = [...optionsList];
              dumpList[index] = option.value;
              this.item.variants.forEach((variant) => {
                if (variant.title == dumpList.join(' / ')) {
                  if (variant.available) {
                    option.innerHTML = option.value;
                    option.dataset.available = true;
                  } else {
                    option.innerHTML = `${option.value} (out of stock)`;
                    option.dataset.available = false;
                  }
                }
              });
            });
            let sortedOptions = [];
            options.forEach((option) => {
              sortedOptions.push(option);
            });
            sortedOptions = sortedOptions.sort(option => {return (option.dataset.available == true || option.dataset.available == 'true') ? -1 : 1});
            select.innerHTML = '';
            sortedOptions.forEach((option) => {
              select.appendChild(option)
            });
          });
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount/100);
        },
        onSubmit() {
            if(!this.selectedVariant) {
                return false;
            }
            this.$emit('addToCart', this.quantity, this.selectedVariant.id, this.item);
        }
    },
    updated: function () {
      if (document.querySelector('#ProductGridContainer .modal-container .variant-selects')) this.updateVariantSelects(document.querySelector('#ProductGridContainer .modal-container .variant-selects'));
    },
    template: `
    <Transition name="modal" @after-leave="onAfterLeave" @before-enter="onEnter">
      <div v-if="item && show" class="modal-mask">
        <div class="modal-wrapper" @click="$emit('close')">
          <div class="modal-container light--scrollbar" @click.stop="">
            <div class="modal-body">
              <div class="row no-gutters">
                <div class="col-lg-6">
                  <div class="quickview-images">
                    <carousel
                        v-if="images"
                        :starting-image="selectedVariantImage"
                        :images="images"
                        @change-image="changeImage"
                    ></carousel>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="quickview-info">
                    <h3 class="card__heading h5"><a :href="item.url" class="full-unstyled-link">{{item.title}}</a></h3> 
                    <h4 class="bs-product-subtitle">{{item.subtitle}}</h4>
                    <a :href="item.url+'#junipProductReviews'+item.id">
                        <span class="junip-product-summary" :data-product-id="item.id"></span>
                    </a>
                    <div class="price-container" v-if="selectedVariant">{{ selectedVariant.available ? formatCurrency(selectedVariant.price) : 'Out of stock'}}</div>
                    <readmore :short-description="item.short_description" :benefits="item.benefits" link="#"/>
                    <template v-if="item.certification_logos !== ''"><div v-html="item.certification_logos"></div></template>
                   <div class="variant-radios" v-if="sortedVariants.length > 1 && item.type != 'Bundle'">
                      <fieldset class="product-form__input">
                        <template v-for="variant in sortedVariants" :key="variant.id">
                          <input type="radio" :id="'size-'+variant.id" 
                                name="size"
                                :value="variant.id"
                                :checked="(variant.id === selectedVariantId)"
                                @change="selectVariant"
                          >
                          <label :for="'size-'+variant.id"> 
                            <strong>{{variant.product_size ? variant.product_size : variant.title }}</strong>
                            <span v-if="variant.variant_size !== ''">{{variant.variant_size}}</span>
                          </label>
                        </template>
                      </fieldset>
                    </div>
                    <div class="variant-selects" v-if="item.variants.length > 1 && item.type == 'Bundle'" >
                      <div class="product-form__input product-form__input--dropdown">
                        <template v-for="(option, index) in item.options" :key="option.name">
                          <label class="form__label" :for="'Option-' + index">{{index + 1}}. {{option.name}}</label>
                          <div class="select">
                            <select :id="'Option-' + index"
                              class="select__select"
                              :name="'options[' + option.name + ']'"
                              @change="selectVariant"
                            >
                              <template v-for="value in option.values" :key="value">
                                <option :value="value" :selected="item.variants.filter(variant => {return variant.id == item.selected_or_first_available_variant})[0].title.indexOf(value) > -1">
                                  {{ value }}
                                </option>
                              </template>
                            </select>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/>
                            </svg>
                          </div>
                        </template>
                        <select class="hidden" data-variant-selector>
                          <template v-for="variant in item.variants" :key="variant.id">
                            <option :value="variant.id" :data-title="variant.title">{{variant.title}}</option>
                          </template>
                        </select>
                      </div>
                    </div>
                    <div class="product-form-wrapper">
                      <div class="product-form__input product-form__quantity">
                        <div class="quantity">
                            <button type="button" class="qty-dec" name="minus" @click="onQtyButtonClick"></button>
                            <input type="text" :name="qtyName" :id="qtyId" :value="quantity" @change="updateProductQty">
                            <button type="button" class="qty-inc" name="plus" @click="onQtyButtonClick"></button>
                        </div>
                      </div>
                      <div class="product-form">
                        <div class="product-form__error-message-wrapper" role="alert" hidden>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
                                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                                <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"/>
                            </svg>
                            <span class="product-form__error-message"></span>
                        </div>
                
                        <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" @submit.prevent="onSubmit">
                            <input type="hidden" name="form_type" value="product" />
                            <input type="hidden" name="utf8" value="✓" />
                            <input type="hidden" name="id" :value="item.id">
                            <div class="product-form__buttons__container">
                                <div class="product-form__buttons">
                                    <button v-if="selectedVariant" type="submit" name="add" class="product-form__submit button button--full-width button--primary"
                                      :class="{loading: loading}"
                                      :disabled="!selectedVariant.available">
                                        <span>{{ selectedVariant.available ? 'Add to cart' : 'Out of stock'}}</span>
                                        <span class="loading-overlay__spinner" :class="{hidden: !loading}">
                                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                            </svg>
                                        </span>
                                        <span class="price" v-if="selectedVariant">{{ formatCurrency(selectedVariant.price) }}</span>
                                    </button>
                                </div>
                                <a href="#" class="wishlist-btn"><span class="sr-only">Save for later</span><span class="active"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="heart"><path d="M50,90.66a2,2,0,0,1-1.4-.57L11,53.65a25.87,25.87,0,0,1,0-37.39,25,25,0,0,1,34.46,0L50,20.67l4.54-4.41a25,25,0,0,1,34.47,0h0a25.87,25.87,0,0,1,0,37.39L51.39,90.09A2,2,0,0,1,50,90.66ZM28.22,13.34a20.73,20.73,0,0,0-14.45,5.79,21.88,21.88,0,0,0,0,31.65L50,85.87,86.23,50.78a21.88,21.88,0,0,0,0-31.65,21,21,0,0,0-28.9,0l-5.94,5.76a2,2,0,0,1-2.79,0l-5.93-5.76A20.69,20.69,0,0,0,28.22,13.34Z"></path></g></svg>
</span><span class="disabled"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="heart"><path d="M87.62,17.7a22.92,22.92,0,0,0-31.69,0L50,23.45,44.06,17.7a22.91,22.91,0,0,0-31.68,0,23.87,23.87,0,0,0,0,34.52L50,88.66,87.62,52.22A23.87,23.87,0,0,0,87.62,17.7Z"></path></g></svg>
</span></a>
                            </div>
                        </form>
                      </div>
                    </div>
                    <a :href="item.url" class="button button--full-width button--secondary"><span>View Full Details</span></a>
                    <div class="text-right subscribe-link-container" v-if="item.selected_or_first_available_selling_plan != 0"><a :href="item.url">Subscribe available</a></div>
                  </div>
                </div>
              </div>
            </div>
            <button class="btn-close modal-close-button" @click="$emit('close')"><span class="aria-description--hidden">Close</span></button>
          </div>
        </div>
      </div>
    </Transition>`
}
const ProductGridVideo = {
    props: {
        media: Object
    },
    computed: {
        src() {
            return `https://www.youtube.com/embed/${this.media.id}?controls=1`;
        }
    },
    template: `<li class="grid__item grid__video"><div class="embed-container"><iframe title="video" width="560" height="315" :src="src" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></li>`
}
const ProductGridItem = {
    components: {
        'currency': ProductGridPrice,
        'sticker': ProductSticker,
        'quickview': ProductQuickView
    },
    directives: {
        'click-outside': clickOutside
    },
    props: {
        item: Object,
        i18n: Object
    },
    emits: ['addToCart','openQuickView','openNotifyModal'],
    data() {
        return {
            selectedVariant: null,
            openVariantOptions: false,
            isRequired: false
        }
    },
    computed: {
        orderVariants() {
            return this.item.variants.sort(variant => {return variant.available ? -1 : 1}).filter(v => v.found === true)
        },
        isGiftCard() {
            return this.item.type === 'gift-cards'
        }
    },
    methods: {
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            }).format(amount/100);
        },
        selectVariant(variant) {
            this.selectedVariant = variant;
            this.openVariantOptions = false;
            this.isRequired = false;
            if(variant.available) {
                this.addToCart();
            } else {
                this.notifyMe();
            }
        },
        addToCart() {
            if(this.item.variants.length > 1 && !this.selectedVariant) {
                this.isRequired = !this.isRequired;
                return false;
            }
            if(this.item.variants.length === 1) {
                this.selectedVariant = this.item.variants[0];
            }
            this.$emit('addToCart', 1, this.selectedVariant.id, this.item);
            this.selectedVariant = null;
        },
        openQuickView() {
            this.$emit('openQuickView',this.item);
        },
        closeOptions() {
            this.isRequired = false;
        },
        openProductPage() {
            window.location.href = this.item.url;
        },
        notifyMe() {
            if(this.item.variants.length > 1) {
                if(!this.selectedVariant) {
                    this.isRequired = !this.isRequired;
                    return false;
                } else {
                    this.openNotifyModal();
                }
            } else {
                this.openNotifyModal();
            }
        },
        openNotifyModal() {
            const variantId = this.selectedVariant ? this.selectedVariant.id : this.item.selected_or_first_available_variant;
            this.$emit('openNotifyModal',variantId);
            this.selectedVariant = null;
        }
    },
    template: `
        <div class="card-wrapper" :class="{'gift-card-wrapper':isGiftCard}" v-click-outside="closeOptions" @click="openProductPage">
            <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
                <div class="card__inner color-background-2 ratio" style="--ratio-percent: 100.0%;">
                    <div class="card__media">
                        <div class="media media--transparent" :class="{'has-hover-image':item.hover_image != ''}">
                            <a :href="item.url" class="full-unstyled-link" @click.stop>
                                <img :src="item.img_url" :alt="item.img_alt" class="motion-reduce main-item-image">
                                <img :src="item.hover_image" alt="" class="motion-reduce hover-image" v-if="item.hover_image != ''">
                            </a>
                        </div>
                        <sticker :item="item" :i18n="i18n"></sticker>
                    </div>
                    <quickview :item="item" @open-quick-view="openQuickView" :i18n="i18n"></quickview>
                </div>
                <div class="card__content">
                    <div class="card__information">
                        <h3 class="card__heading h5">
                            <a :href="item.url" class="full-unstyled-link" @click.stop>{{item.title}}</a>
                        </h3>
                        <h4 class="bs-product-subtitle">{{item.subtitle}}</h4>
                        <div class="card-information"><currency :item="item"></currency></div>
                        <div class="card-atc-wrapper">
                            <div v-if="item.variants.length > 1" class="variant-options" :class="{ open: isRequired }">
                                <strong @click.stop="isRequired = !isRequired">{{isGiftCard ? 'Select Amount' : 'Choose Size'}}</strong>
                                <ul>
                                    <li v-for="variant in orderVariants" :key="variant.id" @click.stop="selectVariant(variant)" :class="{selected: (selectedVariant && selectedVariant.id == variant.id) }">
                                      <span><span>{{variant.product_size ? variant.product_size : variant.title }}</span><em class="not-available" v-if="!variant.available">Out of Stock</em></span>
                                      <strong>{{ formatCurrency(variant.price) }}</strong>
                                      <span v-if="variant.variant_size !== ''">{{variant.variant_size}}</span>
                                    </li>
                                </ul>
                            </div>
                            <a v-if="item.disable_atc" class="button button--full-width button--primary button--link" :href="item.url">
                                <span>Create Your Set ></span>
                            </a>
                            <button v-else-if="item.available" type="button" class="button button--full-width button--primary" :class="{loading: item.loading}" @click.stop="addToCart">
                                <span>Add to cart</span>
                                <span class="loading-overlay__spinner" :class="{hidden: !item.loading}">
                                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                </span>
                            </button>
                            <button v-else type="button" class="button button--full-width button--primary button--notify" @click.stop="notifyMe">
                                <span>Notify Me</span>
                                <span class="loading-overlay__spinner" :class="{hidden: !item.loading}">
                                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                </span>
                            </button>
                            <a :href="item.url" v-if="item.selected_or_first_available_selling_plan != 0" @click.stop>Subscribe available</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
    `
}
